export type ImageRenderMeta = {
  width: number;
  height: number;
};

const fixedMeta = (width: number, height: number): ImageRenderMeta => ({ width, height });

const IMAGE_META: Record<string, ImageRenderMeta> = {
  "/onboarding_lander_science.webp": fixedMeta(900, 502),
  "/romain_skyline.webp": fixedMeta(900, 491),
  "/romain_skyline.avif": fixedMeta(900, 491),
  "/roman_republic.webp": fixedMeta(900, 491),
  "/pirate_engineering.webp": fixedMeta(900, 590),
  "/pirate_engineering.avif": fixedMeta(900, 590),
  "/science_lightspeed.webp": fixedMeta(900, 491),
  "/roman_gladiators.webp": fixedMeta(900, 491),
  "/pysch_representation.webp": fixedMeta(900, 502),
  "/pysch_representation.avif": fixedMeta(900, 502),
  "/science_ac.webp": fixedMeta(900, 491),
  "/history_julius_caesar.webp": fixedMeta(900, 491),
  "/high_court.webp": fixedMeta(900, 491),
  "/science_preindustrial_engineering.webp": fixedMeta(900, 491),
  "/science_chemicals.webp": fixedMeta(1100, 600),
  "/persona_shepard.webp": fixedMeta(1100, 575),
  "/persona_disciple.webp": fixedMeta(1100, 575),
  "/persona_wanderer.webp": fixedMeta(1100, 575),
  "/persona_scribe.webp": fixedMeta(1100, 614),
  "/persona_prophet.webp": fixedMeta(1100, 575),
  "/persona_berean.webp": fixedMeta(1100, 614),
  "/characters_1.webp": { width: 500, height: 809 },
  "/characters_2.webp": { width: 500, height: 750 },
  "/characters_3.webp": { width: 500, height: 757 },
  "/characters_4.webp": { width: 500, height: 732 },
  "/vireo/background.jpg": fixedMeta(1200, 800),
  "/vireo/Collateral/phone-in-hand.webp": fixedMeta(1024, 1536),
  "/vireo/Collateral/image-use-what-you-have.avif": fixedMeta(1024, 1536),
  "/vireo/background-2.jpg": fixedMeta(1200, 800),
  "/vireo/brand-moment-background.jpg": fixedMeta(1200, 800),
  "/vireo/Social-Preview.png": fixedMeta(1024, 518),
  "/vireo/Collateral/hero-checkout.webp": fixedMeta(1200, 604),
  "/vireo/adaptive-icon.png": fixedMeta(512, 512),
  "/vireo/mascot/mascot-quick-meals.webp": fixedMeta(492, 462),
  "/vireo/mascot/mascot-empty-search.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-photo-of-ingredients.webp": fixedMeta(640, 601),
  "/vireo/mascot/mascot-import.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-learning-skills.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-family-meals.webp": fixedMeta(559, 525),
  "/vireo/mascot/mascot-scan.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-saving-money.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-eating-healthy.webp": fixedMeta(800, 800)
};

export const getImageRenderMeta = (src?: string | null): ImageRenderMeta | undefined => {
  if (!src) {
    return undefined;
  }
  return IMAGE_META[src];
};

export const getImagePreloadCandidates = (src?: string | null): string[] => {
  if (!src) {
    return [];
  }

  return [src];
};

export const getImagePreloadCandidatesForSources = (
  sources?: Array<string | null | undefined>
): string[] => {
  if (!sources || sources.length === 0) {
    return [];
  }

  return Array.from(new Set(sources.flatMap((source) => getImagePreloadCandidates(source))));
};
